// import { vb as act } from '@tencent/vbproxy-grpc/proto/ao_vb_loan_activity_server';

// export const { DiscountType } = act.loan.ao.activity;
export enum DiscountType {
  DISCOUNT_TYPE_FIX = 1,
  DISCOUNT_TYPE_PRECENT = 2,
  DISCOUNT_TYPE_FREE_BY_DAY = 3,
  DISCOUNT_TYPE_FREE_BY_TENOR = 4,
  DISCOUNT_TYPE_FREE_BY_MONTH = 5,
  DISCOUNT_TYPE_PRECENT_BY_MONTH = 6,
}

export enum LimitState {
  NORMAL = 'NORMAL',
  INIT = 'INIT',
  ACCT_FREEZING = 'ACCT_FREEZING',
  CREATING = 'CREATING',
  TIMEOUT = 'TIMEOUT',
  REJECT = 'REJECT',
  CANCEL = 'CANCEL',
  USING = 'USING',
  CLOSE = 'CLOSE',
  BINDING = 'BINDING',
  CONFIRMTIMEOUT = 'CONFIRMTIMEOUT',
  OFFERTIMEOUT = 'OFFERTIMEOUT',
  LIMIT_FREEZING = 'LIMIT_FREEZING',
}

export interface ICommonRes<T> {
  data?: T;
  message: string;
}

export interface IIconItem {
  iconName: string;
  'iconTitle_en-GB': string;
  'iconTitle_zh-CN': string;
  'iconTitle_zh-HK': string;
  title: string;
}

export interface ILoanCommonItem {
  'en-GB': string;
  id: string;
  'zh-CN': string;
  'zh-HK': string;
}

export interface ICommonMapItem {
  id: string;
  value: string;
}
export interface IIndexConfig {
  iconList: IIconItem[];
  indexImg: string;
  loanTarget: ICommonMapItem[];
  loanTerms: ICommonMapItem[];
}

export interface IKeyPairForWork {
  key: string;
  text: string;
}

export interface StringMap {
  [key: string]: string;
}

export interface IWorkInfo {
  job: IKeyPairForWork;
  industry: IKeyPairForWork;
  incomeRange: IKeyPairForWork;
  incomeFrom: {
    custom: string;
    options: IKeyPairForWork[];
  };
  ioAmount: IKeyPairForWork;
  employments: StringMap[];
  position: IKeyPairForWork;
}

export interface IKeyValueMap {
  key: string;
  value: string;
}

export interface IUserInfoResp {
  authWay: number;
  name: string;
  enName: string;
  firstName: string;
  lastName: string;
  nickName: string;
  wxNickName: string;
  wxHeadUrl: string;
  gsmCode: string;
  mobile: string;
  isBindWx: number;
  isBindFb: number;
  isBindMobile: number;
  isBindEmail: number;
  isBindApple: number;
  birthAddress: string;
  residenceAddress: string;
}

export enum IProofVoucherType {
  ADDRESS = 1, // 地址证明
  INCOME = 2, // 收入证明
  WORK_VISA = 3, // 工作签证
  PASS = 4, // 通行证
  LEASE = 5, // 租房合同
  LABOUR = 6, // 劳动合同
  TESLALICENCE = 7, // 车辆证明
  LOANASSETS = 8, // 资产证明
  TESLAORDER = 9 // 订单证明
}

export enum IProofReviewStatus {
  PENDING = 10, // 待审核
  REJECTED = 20, // 拒绝
  PASS = 30, // 通过
  RETRY_UPLOAD = 40, // 需要重新上传
}

export enum IProofType {
  ADDRESS = 1, // 地址证明
  INCOME = 2, // 收入证明
  NON_PERMANENT = 3, // 非永居身份证明
  TESLALICENCE = 4, // 车辆证明
}
// 特斯拉车主车簿工单审核状态
export enum ProofReviewStatus {
  PROOF_REVIEW_STATUS_PENDING_UPLOAD = 0, // 待上传
  PROOF_REVIEW_STATUS_NOT_READY = 5, // 未就绪
  PROOF_REVIEW_STATUS_PENDING = 10, // 待审核
  PROOF_REVIEW_STATUS_REJECTED = 20, // 拒绝
  PROOF_REVIEW_STATUS_PASS = 30, // 通过
  PROOF_REVIEW_STATUS_RETRY_UPLOAD = 40, // 需要重新上传
  PROOF_REVIEW_STATUS_INVALID = 50, // 申请废弃
  PROOF_REVIEW_STATUS_USE_AUTO_APPROVAL_VALUE = 60, // 使用自动审批值
}
// tesila白名单状态
export enum EnumWhitelistStatus {
  WHITELIST_STATUS_VALID = 10, // 生效状态
  WHITELIST_STATUS_TOCONFIRM = 11, // 待确认
  WHITELIST_STATUS_INVALID = 20, // 失效状态
  WHITELIST_STATUS_TOBIND = 30, // 待绑定状态
  WHITELIST_STATUS_TOCHASE = 40, // 待追踪状态
  WHITELIST_STATUS_CHASED = 50, // 追踪完成状态
  WHITELIST_STATUS_TO_APPROVE = 60, // 待审批状态
  WHITELIST_STATUS_APPROVE_REJECTED = 70, // 审批拒绝状态
  WHITELIST_STATUS_APPROVE_EXPIRED = 80, // 审批超时状态
  WHITELIST_STATUS_DELETE = 90, // 已删除状态
}

export interface ICheckCarOwnerInfoData {
  businessId: string;
  approvalStatus: number;
  whitelistStatus: EnumWhitelistStatus;
  rejectReason: string;
  vehicleNo: string;
  businessTime: number;
  sceneReason: string[];
  status: EnumWhitelistStatus;
  brandId: string;
  rnNo: string;
}

export interface ICheckTeslaWhiteAndOwnerInfoData {
  businessId: string;
  businessTime: number;
  approvalStatus: number;
  rejectReason: string;
  sceneReason: string[];
  whitelistStatus?: EnumWhitelistStatus;
  vehicleNo: string;
  rnNo: string;
  isInTeslaWhite: boolean;
  brandId: string;
}

export interface IRegisterPinRespData {
  whitelist_business_id: string;
  whitelist_business_time: number;
  scene_reason: string[];
  scene: number;
}

export interface IRejectReasonInfo {
  'zh-CN': string;
  'zh-HK': string;
  'en-GB': string;
}

export interface IListItem {
  cardNo: string;
  acctNo: string;
  acctName: string;
  acctAlias: string;
  ccy: string;
  country: string;
  openDate: string;
  usableBalance: string;
  balance: string;
  attribute: string;
  limit: string;
}

export interface ICoupon {
  coupon_id: string;
  discount_type?: number;
  discount_value?: string;
  not_use_rule?: INotUseRule[];
}

export interface INormalCoupon {
  couponId: number;
  couponCode: string;
  awardConfId: string;
  couponName: string;
  business: number;
  businessName: string;
  type: number;
  typeName: string;
  currency: string;
  desc: string;
  article: string;
  state: number;
  channel: number;
  addRange: string;
  startValidTime: string;
  endValidTime: string;
  rules: {
    key: string;
    value: string;
  }[];
  date1: number;
  date2: number;
  char1: string;
  char2: string;
  char3: string;
  int1: number;
  int2: number;
  int3: number;
  text: string;
}

export interface ICouponDetail {
  coupon_id: string;
  discount_type: 1 | 2;
  discount_value: string;
  discount_rate_info: {
    day_rate: string;
    overdue_day_rate: string;
    overdue_year_rate: string;
    year_rate: string;
  };
  origin_rate_info: {
    day_rate: string;
    overdue_day_rate: string;
    overdue_year_rate: string;
    year_rate: string;
  };
}

export interface INotUseRule {
  key: string;
  value: string;
}

export interface IQueryFrozeInfoReq {
  frozeStatus?: string;
  frozeKindCode?: string;
}

export interface IRightActDate {
  /** 活动时间 */
  date: string[];
}

export interface IRightItem {
  limitFloor: string; // 提款金额下限
  isIncludeFloor: string; // 是否包含下限金额
  limitUpper: string; // 提款金额上限
  isIncludeUpper: string; // 是否包含上限金额
  rank: string; // 提款等级
  rankIndex: string; // 提款等级索引
  sorts: IRightSortConfig[]; // 权益大类列表
}

export interface IRightSortConfig {
  sortName: string // 权益大类名称
  sortOrder: string // 权益大类优先级
  rights: IRightConfig[] // 奖品列表
  chooseReceiveCount: string // N选1奖品——总计可领取数量
  chooseReceiveMonthCount: string // N选1奖品——月可领取数量
  chooseRights: IRightConfig[] // N选1奖品列表
}
export interface IRightConfig {
  key: string; // 奖品key
  order: string; // 展示优先级
  activity: string[]; // 关联活动
  rightSize: string[]; // 详情页奖品规格
  homeIcon: string; // 首页奖品图片链接
  homeIconDisabled: string // 首页已领取奖品图片链接
  homeName: string; // 首页奖品名称
  homeInfo: string; // 首页奖品说明
  detailIcon: string; // 详情页图标链接
  detailName: string; // 详情页奖品名称
  detailInfoType: string; // 详情页奖品说明类型
  detailInfoText: string[]; // 详情页奖品说明——文案
  detailInfoPic: string; // 详情页奖品说明——图片链接
  detailInfoReceiveCount: string; // 详情页奖品说明——总计可领取数量
  detailInfoReceiveMonthCount: string; // 详情页奖品——月可领取数量
  rightSuccessInfo: string; // 奖品发放成功说明
  detailTips: string[]; // 详情页说明文案
  receiveInfo: string; // 领取记录页说明文案
}

export interface ICheckCarOwnerRightReq {
  /** 车主权益品牌 */
  brand: string
  startTime: string
  endTime: string
}

export interface ICheckLoanStatusReq {
  proNo: string;
  /** 核心产品号 */
  baseProNo: string;
  startTime: string;
  endTime: string;
}

export interface ICheckLoanStatusResp {
  overdue: boolean;
  prepay: boolean;
  loanAmount: number;
  isfirst: boolean;
  writeOff: boolean;
  proNo: string;
  baseProNo: string;
}

// 产品特点
interface ITags {
  text: string;
  icon: string;
  desc: string;
  titleMark: string;
  descMark: string;
}

// 邀请码
interface IInviteCode {
  text: string;
  protoKey: string;
}

export interface IProductViewData {
  mainTitle: string;
  subTitle: string;
  desc: string;
  proto: string;
  productNo: string;
  tags: ITags[];
  actCode: string;
  actCodeProof: IInviteCode[];
  applyTips: string;
  remark: string;
  allowNoReside: string;
}
export interface ICheckNoTeslaWhiteAndIsElectricCarResp {
  isInNoTeslaWhite: boolean;
  isElectricCar: boolean;
}

export interface IProductBillItem {
  /** 产品核心号 */
  baseProNo: string;
  /** 起息日期 */
  start: string;
  /** 创建日期 */
  createAt: string;
  /** 币种 */
  ccyCode: string;
  /** 借据金额 */
  loanAmt: string;
  /** 借据编号 */
  loanNo: string;
  /** 预期标志 */
  overdue: boolean;
  /** 贷款状态 */
  close: boolean;
  /** 核销标志 */
  writeOff: boolean;
  /** 当月到期还款日 */
  nextRepayDate: string;
  /** 当月应还金额 */
  totRepay: string;
  /** 本期还款是否还清 */
  isRepayed: boolean;
  /** 借据是否还清 */
  isFinished: boolean;
  isDelay: boolean;
  trxnDateDue: boolean;
  cardNo: string;
  extnfo: string
}
export interface IAllProductsBillListRes {
  billList: IProductBillItem[];
  nextBillList: IProductBillItem[];
  noBill: boolean;
  curMonth: string;
  nextMonth: string;
  curMonthRepay: string;
  nextMonthRepay: string;
  recentRepayDay: string;
  overdue: boolean;
  writeOff: boolean;
}
export interface ITeslaRegisterPageConfigData {
  start_time: number;
  end_time: number;
  state: number;
  ext_info: string;
}

export enum IReuseFlag {
  REUSE_FLAG_CAN_NOT_REUSE = 0, // 不复用
  REUSE_FLAG_CAN_REUSE = 1, // 复用
  REUSE_FLAG_NOT_NEED_REUSE = 2, // 无需复用，比如永居用户就不需要身份证明了
  REUSE_FLAG_PROOF_EXIST = 3,
}

export enum IUploadType {
  NO = -1,
  APPROVING = 0,
  NEED_UPLOAD = 1,
}

export interface IUrlUploadItem {
  /** 工单类型 */
  proofType: number;
  /** 材料类型 */
  type: number;
  uploadType: number;
  uploadFlag: number;
  rejectReason: string;
  scene: number; // 落入场景
  scene_reason: string[]; // 落入场景
  extInfo?: any;
  reuse?: boolean;
  reuseId?: string;
  businessId?: string;
}

export enum IncreaseLimitType {
  UNKNOWN = 0,
  NORMALINCREASE = 1,
  ADDRESSBACKINCREASE = 2,
}

export enum IZeroOne {
  ZERO = 0,
  ONE = 1,
}

export interface ISubmitParam {
  delayCheck?: IZeroOne;
  from?: string;
  incomeConfig?: {
    declareIncomeGetlimit?: string;
    /** 这里post过去之后 是在地址证明提交的时候 附带上复用的收入证明 */
    incomeReuseProofId?: string;
    userApplyIncreaseLimit?: IncreaseLimitType;
  };
  addressConfig?: {
    addresssBackConfirm?: IZeroOne
    tuAddressBuildingcode?: string
  }
  teslaConfig?: {
    isTeslaLicenseLatest?: IZeroOne
  },
  confirmDay?: string
  busId: string,
  time: number,
  productNo: string,
  uploadItems: IUrlUploadItem[],
  // rn/车身号
  recordNo?: string
}

export interface ICalConfig {
  dayRate: string;
  amtRangeLeft: string;
  amtRangeRight: string;
  termRangeLeft: string;
  termRangeRight: string;
  beginDateTime: string;
  endDateTime: string;
  defaultAmt: string;
  defaultTerm: string;
}